var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { CHANGE_ACTIVITY_SUCCESS, CLEAR_PROJECT, CREATE_DEFAULT_CONFIGURATION_SUCCESS, GET_PROJECT_SUCCESS, GET_PROJECTS_WITH_STATS_SUCCESS, SAVE_CREATED_PROJECT_SNAPSHOT, UPDATE_PROJECT_CONFIGURATION_SUCCESS, UPDATE_PROJECT_STYLE_SUCCESS } from './projects.action';
import { createSelector } from 'reselect';
import { sumImpressions } from '../../shared/utils/sumImpressions';
import { getActiveTypeLabel } from '../../shared/utils/active-type-formatter';
export var initialState = {
    list: {
        data: [],
        total: 0
    },
    activeProject: null
};
export function projectsReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case GET_PROJECTS_WITH_STATS_SUCCESS:
            var data = action.payload.map(function (_a) {
                var id = _a.id, active = _a.active, device = _a.device, domain = _a.domain, name = _a.name, activeType = _a.activeType, stats = _a.stats;
                var impressions = sumImpressions(stats);
                var leads = (stats && stats.popupSubmitted) || 0;
                return {
                    id: id,
                    name: name,
                    activeType: getActiveTypeLabel(activeType),
                    status: active,
                    device: device,
                    domain: domain,
                    impressions: impressions,
                    leads: leads,
                    conversion: impressions ? parseFloat((leads / impressions * 100).toFixed(2)) : 0
                };
            });
            return __assign({}, state, { list: { data: data, total: data.length } });
        case GET_PROJECT_SUCCESS:
        case UPDATE_PROJECT_CONFIGURATION_SUCCESS:
        case UPDATE_PROJECT_STYLE_SUCCESS:
            return __assign({}, state, { activeProject: action.payload });
        case CHANGE_ACTIVITY_SUCCESS: {
            var newData = state.list.data.map(function (project) {
                return project.id === action.payload.projectId ? __assign({}, project, { status: action.payload.active }) : project;
            });
            return __assign({}, state, { list: __assign({}, state.list, { data: newData }) });
        }
        case CLEAR_PROJECT:
            return __assign({}, state, { activeProject: action.payload, createdProjectSnapshot: null });
        case SAVE_CREATED_PROJECT_SNAPSHOT:
            return __assign({}, state, { createdProjectSnapshot: action.payload });
        case CREATE_DEFAULT_CONFIGURATION_SUCCESS:
            return __assign({}, state, { activeProject: action.payload });
        default: {
            return state;
        }
    }
}
export var getList = function (state) { return state.list.data; };
export var getListTotal = function (state) { return state.list.total; };
export var getActiveProject = function (state) { return state.activeProject; };
export var getCreatedProjectSnapshot = function (state) { return state.createdProjectSnapshot; };
export var getMainProjectsSelector = function (state) { return state.leadGeneration.projects; };
export var getProjectsSelector = createSelector(getMainProjectsSelector, getList);
export var getProjectsTotalSelector = createSelector(getMainProjectsSelector, getListTotal);
export var getActiveProjectSelector = createSelector(getMainProjectsSelector, getActiveProject);
export var getCreatedProjectSnapshotSelector = createSelector(getMainProjectsSelector, getCreatedProjectSnapshot);
